.md_help {
    max-width: 280px;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 10px;

    code {
        background-color: var(--axl-surface-2);
        border-radius: 3px;
        box-shadow: 0 0 0 1px var(--axl-hair);
        color: var(--axl-danger);
        padding: 1px 3px;
    }
}